import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

// Import images

const ExamSlider = () => {
  const [personalInfo, setPersonalInfo] = useState([]);
  const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state

  // const fetchExam = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/getTeachersData`);
  //     setPersonalInfo(response.data.data.personalInfo);
  //     setProfileImg(response.data.data.profileImg);
  //   } catch (err) {
  //     console.error("Error fetching data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchExam = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getcompetitiveExamsData`);
        console.log("response fhff",response)
      setPersonalInfo(response.data);
      // setProfileImg(response.data.data.profileImg);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExam();
  }, []); 
  return (
    <div className="institute-slider-container event-slider">
      {/* Show loader if data is still being fetched */}
      {loading ? (
        <p>Loading exams...</p>
      ) : personalInfo.length > 0 ? (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          }}
        >
          {personalInfo.map((profile, index) => (
            <div class="pd-20" key="1"> 
            <div class="course-item wow fadeInUp" data-wow-delay=".25s">      
                <div class="course-img">
                    <span class="curve"></span>
                    <h5 class="course-tag">{profile.pdcet}</h5>
                </div>
                <div class="course-content pt-3">
                    <div class="course-bottom">
                        <div class="course-bottom-left">
                            <span>Participating Colleges</span> 
                        </div> 
                        <span class="course-price">{profile.participating_colleges}</span>
                    </div>
                    <div class="course-bottom">
                        <div class="course-bottom-left">
                            <span>Exam Date</span> 
                        </div> 
                        {/* <span class="course-price"> {profile?.exam_date}</span> */}
                        <span className="course-price">
  {profile?.exam_date ? new Date(profile.exam_date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : ""}
</span>

                    </div>
                    <div class="course-bottom">
                        <div class="course-bottom-left">
                            <span>Exam Level</span> 
                        </div> 
                        <span class="course-price">{profile?.exam_level}</span>
                    </div>
                    
                    <div class="course-bottom">
                        <div class="course-bottom-left">
                            <span>Application Process</span> 
                        </div> 
                        <span><a href="#"><i class="far fa-arrow-right"></i></a></span>
                    </div>  
                    
                    <div class="course-bottom">
                        <div class="course-bottom-left">
                            <span>Exam Info</span> 
                        </div> 
                        <span><a href="#"><i class="far fa-arrow-right"></i></a></span>
                    </div> 
                </div>
            </div>     
        </div>

            
          ))}
        </OwlCarousel>
      ) : (
        <p>No institutes available.</p>
      )}
    </div>
  );
};

export default ExamSlider;